const EN = {
    title: 'Products',
    subtitle: 'Product', // used in submenu product in customer details
    table: {
        title: 'Products List',
        columns: {
            accountNumber: 'Product No.',
            client: 'Seller',
            dni: 'INE',
            description: 'Description',
            amount: 'Amount',
            createdAt: 'Creation Date',
            paymentDate: 'Last Payment Attempt',
            status: 'Status',
            accountPosition: 'Product Position'
        },
    }
};

export default EN;
